(() => {
  const dialog = document.getElementById('YunaCart');
  if (!dialog || typeof window.YunaCart?.open === 'function') return;
  const sectionId = dialog.dataset.sectionId;
  const root = window.Shopify?.routes?.root || '/';
  let busy = false;
  let opener = null;
  const errorBox = dialog.querySelector('[data-yuna-cart-error]');
  function showError(message) { errorBox.textContent = message || dialog.dataset.errorMessage; errorBox.hidden = false; }
  function setBusy(value) {
    busy = value;
    dialog.setAttribute('aria-busy', String(value));
    dialog.querySelectorAll('[data-cart-change],[data-yuna-cart-add],[data-yuna-protection],button[name=checkout]').forEach(button => button.disabled = value);
  }
  function render(sections) {
    const html = sections?.[sectionId];
    if (!html) return false;
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const next = parsed.querySelector('[data-yuna-cart-content]');
    if (!next) return false;
    dialog.querySelector('[data-yuna-cart-content]').replaceWith(next);
    const count = Number(next.dataset.count);
    document.querySelectorAll('[data-yuna-cart-count]').forEach(badge => { badge.textContent = count; badge.hidden = count === 0; });
    document.querySelectorAll('[data-yuna-cart-trigger]').forEach(link => link.setAttribute('aria-label', 'Cart, ' + count));
    return true;
  }
  async function refresh() {
    const response = await fetch(root + '?sections=' + encodeURIComponent(sectionId));
    if (!response.ok || !render(await response.json())) throw new Error(dialog.dataset.errorMessage);
  }
  async function open(sections) {
    opener = document.activeElement;
    if (!dialog.open) dialog.showModal();
    errorBox.hidden = true;
    setBusy(true);
    try { if (!render(sections)) await refresh(); }
    catch (error) { showError(error.message); }
    finally { setBusy(false); dialog.querySelector('[data-yuna-cart-close]')?.focus(); }
  }
  function close() { dialog.close(); opener?.focus?.(); }
  dialog.addEventListener('cancel', event => { event.preventDefault(); close(); });
  dialog.addEventListener('click', async event => {
    if (event.target === dialog || event.target.closest('[data-yuna-cart-close]')) { close(); return; }
    const pager = event.target.closest('[data-yuna-recommendation-step]');
    if (pager) {
      const cards = Array.from(dialog.querySelectorAll('[data-yuna-recommendation]'));
      const index = cards.findIndex(card => !card.hidden);
      const next = (index + Number(pager.dataset.yunaRecommendationStep) + cards.length) % cards.length;
      cards.forEach((card, i) => card.hidden = i !== next);
      dialog.querySelector('[data-yuna-recommendation-position]').textContent = (next + 1) + ' / ' + cards.length;
      return;
    }
    const addButton = event.target.closest('[data-yuna-cart-add],[data-yuna-protection]');
    if (addButton) {
      if (busy) return;
      const protection = addButton.hasAttribute('data-yuna-protection');
      const removing = protection && addButton.getAttribute('aria-checked') === 'true';
      const payload = { sections: [sectionId], sections_url: root };
      if (removing) payload.updates = Object.fromEntries(addButton.dataset.keys.split(',').filter(Boolean).map(key => [key, 0]));
      else payload.items = [{ id: Number(protection ? addButton.dataset.yunaProtection : addButton.dataset.yunaCartAdd), quantity: 1 }];
      errorBox.hidden = true;
      setBusy(true);
      try {
        const response = await fetch(root + (removing ? 'cart/update.js' : 'cart/add.js'), { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(payload) });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || result.message || dialog.dataset.errorMessage);
        if (!render(result.sections)) await refresh();
        dialog.querySelector(protection ? '[data-yuna-protection]' : '[data-yuna-cart-close]')?.focus();
      } catch (error) { showError(error.message); }
      finally { setBusy(false); }
      return;
    }
    const button = event.target.closest('[data-cart-change]');
    if (!button || busy) return;
    const key = button.dataset.key;
    const action = button.dataset.action;
    const quantity = Number(button.dataset.quantity);
    errorBox.hidden = true;
    setBusy(true);
    try {
      const response = await fetch(root + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity, sections: [sectionId], sections_url: root }) });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || result.message || dialog.dataset.errorMessage);
      if (!render(result.sections)) await refresh();
      const next = Array.from(dialog.querySelectorAll('[data-cart-change]')).find(el => el.dataset.key === key && el.dataset.action === action);
      (next || dialog.querySelector('[data-yuna-cart-close]'))?.focus();
    } catch (error) { showError(error.message); }
    finally { setBusy(false); }
  });
  document.addEventListener('click', event => {
    const link = event.target.closest('[data-yuna-cart-trigger]');
    if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    open();
  });
  window.YunaCart = { open, refresh, sectionId };
})();
